var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrowave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "microwave_svg__st0",
    d: "M88 25.2H12c-3 0-5.5 2.5-5.5 5.5v37.9c0 3 2.5 5.5 5.5 5.5h76c3 0 5.5-2.5 5.5-5.5V30.7c0-3-2.5-5.5-5.5-5.5zM10.2 68.6V30.7c0-1 .8-1.8 1.8-1.8h56.1v41.6H12c-1 0-1.8-.9-1.8-1.9zm79.6 0c0 1-.8 1.8-1.8 1.8H71.8V28.9H88c1 0 1.8.8 1.8 1.8v37.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "microwave_svg__st0",
    d: "M74.3 32.1h13.5v5.4H74.3zM84.5 60.7h-6.9c-2.3 0-4.2 1.9-4.2 4.2 0 2.3 1.9 4.2 4.2 4.2h6.9c2.3 0 4.2-1.9 4.2-4.2 0-2.4-1.9-4.2-4.2-4.2zm0 4.6h-6.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h6.9c.3 0 .5.2.5.5s-.2.5-.5.5zM59.9 32.2h-40c-3 0-5.5 2.5-5.5 5.5v23.8c0 3 2.5 5.5 5.5 5.5H60c3 0 5.5-2.5 5.5-5.5V37.7c-.1-3-2.5-5.5-5.6-5.5zm1.9 29.4c0 1-.8 1.8-1.8 1.8H19.9c-1 0-1.8-.8-1.8-1.8V37.7c0-1 .8-1.8 1.8-1.8H60c1 0 1.8.8 1.8 1.8v23.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "microwave_svg__st0",
    cx: 86.2,
    cy: 43.2,
    r: 2.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "microwave_svg__st0",
    cx: 81.1,
    cy: 43.2,
    r: 2.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "microwave_svg__st0",
    cx: 75.9,
    cy: 43.2,
    r: 2.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "microwave_svg__st0",
    cx: 86.2,
    cy: 49.4,
    r: 2.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "microwave_svg__st0",
    cx: 81.1,
    cy: 49.4,
    r: 2.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "microwave_svg__st0",
    cx: 75.9,
    cy: 49.4,
    r: 2.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "microwave_svg__st0",
    cx: 86.2,
    cy: 55.6,
    r: 2.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "microwave_svg__st0",
    cx: 81.1,
    cy: 55.6,
    r: 2.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "microwave_svg__st0",
    cx: 75.9,
    cy: 55.6,
    r: 2.4
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmZmIj4NCgk8Zz4NCgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTg4LDI1LjJIMTJjLTMsMC01LjUsMi41LTUuNSw1LjV2MzcuOWMwLDMsMi41LDUuNSw1LjUsNS41aDc2YzMsMCw1LjUtMi41LDUuNS01LjVWMzAuNw0KCQkJQzkzLjUsMjcuNyw5MSwyNS4yLDg4LDI1LjJ6IE0xMC4yLDY4LjZWMzAuN2MwLTEsMC44LTEuOCwxLjgtMS44aDU2LjF2NDEuNkgxMkMxMSw3MC41LDEwLjIsNjkuNiwxMC4yLDY4LjZ6IE04OS44LDY4LjYNCgkJCWMwLDEtMC44LDEuOC0xLjgsMS44SDcxLjhWMjguOUg4OGMxLDAsMS44LDAuOCwxLjgsMS44TDg5LjgsNjguNkw4OS44LDY4LjZ6Ij48L3BhdGg+DQoJCTxyZWN0IHg9Ijc0LjMiIHk9IjMyLjEiIGNsYXNzPSJzdDAiIHdpZHRoPSIxMy41IiBoZWlnaHQ9IjUuNCI+PC9yZWN0Pg0KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNODQuNSw2MC43aC02LjljLTIuMywwLTQuMiwxLjktNC4yLDQuMmMwLDIuMywxLjksNC4yLDQuMiw0LjJoNi45YzIuMywwLDQuMi0xLjksNC4yLTQuMg0KCQkJQzg4LjcsNjIuNSw4Ni44LDYwLjcsODQuNSw2MC43eiBNODQuNSw2NS4zaC02LjljLTAuMywwLTAuNS0wLjItMC41LTAuNWMwLTAuMywwLjItMC41LDAuNS0wLjVoNi45YzAuMywwLDAuNSwwLjIsMC41LDAuNQ0KCQkJUzg0LjgsNjUuMyw4NC41LDY1LjN6Ij48L3BhdGg+DQoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01OS45LDMyLjJIMTkuOWMtMywwLTUuNSwyLjUtNS41LDUuNXYyMy44YzAsMywyLjUsNS41LDUuNSw1LjVoNDAuMWMzLDAsNS41LTIuNSw1LjUtNS41VjM3LjcNCgkJCUM2NS40LDM0LjcsNjMsMzIuMiw1OS45LDMyLjJ6IE02MS44LDYxLjZjMCwxLTAuOCwxLjgtMS44LDEuOEgxOS45Yy0xLDAtMS44LTAuOC0xLjgtMS44VjM3LjdjMC0xLDAuOC0xLjgsMS44LTEuOGg0MC4xDQoJCQljMSwwLDEuOCwwLjgsMS44LDEuOEw2MS44LDYxLjZMNjEuOCw2MS42eiI+PC9wYXRoPg0KCQk8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSI4Ni4yIiBjeT0iNDMuMiIgcj0iMi40Ij48L2NpcmNsZT4NCgkJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iODEuMSIgY3k9IjQzLjIiIHI9IjIuNCI+PC9jaXJjbGU+DQoJCTxjaXJjbGUgY2xhc3M9InN0MCIgY3g9Ijc1LjkiIGN5PSI0My4yIiByPSIyLjQiPjwvY2lyY2xlPg0KCQk8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSI4Ni4yIiBjeT0iNDkuNCIgcj0iMi40Ij48L2NpcmNsZT4NCgkJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iODEuMSIgY3k9IjQ5LjQiIHI9IjIuNCI+PC9jaXJjbGU+DQoJCTxjaXJjbGUgY2xhc3M9InN0MCIgY3g9Ijc1LjkiIGN5PSI0OS40IiByPSIyLjQiPjwvY2lyY2xlPg0KCQk8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSI4Ni4yIiBjeT0iNTUuNiIgcj0iMi40Ij48L2NpcmNsZT4NCgkJPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iODEuMSIgY3k9IjU1LjYiIHI9IjIuNCI+PC9jaXJjbGU+DQoJCTxjaXJjbGUgY2xhc3M9InN0MCIgY3g9Ijc1LjkiIGN5PSI1NS42IiByPSIyLjQiPjwvY2lyY2xlPg0KCTwvZz4NCjwvc3ZnPg==";
export { SvgMicrowave as ReactComponent };